export default "__VITE_ASSET__BClbtmtO__"